import React, { useState, useEffect } from 'react'
import { Grid } from '@mui/material'
import ModalComponent from '../../../components/modals'
import CustomSnackbar from '../../../components/snackbar'
import { callApiAsync, getSurveyAnswerById } from '../../../services/apiService'
import { formatCustomDateIsoString } from '../../../services/dateService'

const ViewSurveyResultsModal = ({ open, handleClose, answerId }) => {
    const [loading, setLoading] = useState(false)
    const [surveyData, setSurveyData] = useState(null)
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')
    const [snackbarSeverity, setSnackbarSeverity] = useState('success')

    useEffect(() => {
        if (open && answerId) {
            loadSurveyResults()
        } else if (!open) {
            setSurveyData(null)
        }
    }, [open, answerId])

    const loadSurveyResults = async () => {
        setLoading(true)
        await callApiAsync(
            () => getSurveyAnswerById(answerId),
            (resp) => {
                const data = resp?.data ?? resp
                setSurveyData(data)
                setLoading(false)
            },
            (error) => {

            }
        )
    }

    return (
        <>
            <ModalComponent
                open={open}
                handleClose={handleClose}
                title="RESULTADOS DE ENCUESTA"
                width="90%"
                maxWidth="900px"
            >
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <p>Cargando resultados...</p>
                    </div>
                ) : !surveyData ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <p>No se encontraron resultados</p>
                    </div>
                ) : (
                    <div style={{ maxHeight: '70vh', overflowY: 'auto', padding: '10px' }}>
                        <div className="mb-20">
                            <div style={{ 
                                border: '2px solid #6C5CE7', 
                                borderRadius: '8px', 
                                padding: '15px', 
                                marginBottom: '20px',
                                backgroundColor: '#f8f9fa'
                            }}>
                                <h2 className="title-bio-details-chard" style={{ 
                                    marginBottom: '12px', 
                                    color: '#6C5CE7',
                                    fontSize: '16px'
                                }}>
                                    Resultados de la Encuesta
                                </h2>
                                {surveyData.userName && (
                                    <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                        Usuario: <strong>{surveyData.userName}</strong>
                                    </p>
                                )}
                                {surveyData.orderNumber && (
                                    <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                        Número de Orden: <strong>{surveyData.orderNumber}</strong>
                                    </p>
                                )}
                                {surveyData.responseDate && (
                                    <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '10px' }}>
                                        Fecha de Respuesta: <strong>{formatCustomDateIsoString(String(surveyData.responseDate))}</strong>
                                    </p>
                                )}
                            </div>

                            {surveyData.orderInfo && (
                                <div style={{ 
                                    border: '1px solid #e0e0e0', 
                                    borderRadius: '8px', 
                                    padding: '15px', 
                                    marginBottom: '20px',
                                    backgroundColor: '#fff'
                                }}>
                                    <h3 className="select-form-label" style={{ 
                                        color: '#6C5CE7', 
                                        fontWeight: 'bold',
                                        marginBottom: '12px',
                                        fontSize: '14px'
                                    }}>
                                        Información de la Orden
                                    </h3>
                                    <Grid container spacing={2}>
                                        {surveyData.orderInfo.origin && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Origen:</strong> {surveyData.orderInfo.origin}
                                                </p>
                                            </Grid>
                                        )}
                                        {surveyData.orderNumber && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Nro de Orden:</strong> {surveyData.orderNumber}
                                                </p>
                                            </Grid>
                                        )}
                                        {surveyData.orderInfo.provider && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Proveedor:</strong> {surveyData.orderInfo.provider}
                                                </p>
                                            </Grid>
                                        )}
                                        {surveyData.orderInfo.transportMode && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Modalidad de Transporte:</strong> {surveyData.orderInfo.transportMode}
                                                </p>
                                            </Grid>
                                        )}
                                        {surveyData.orderInfo.departureDateProvider && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Fecha salida Inst. proveedor:</strong> {formatCustomDateIsoString(String(surveyData.orderInfo.departureDateProvider))}
                                                </p>
                                            </Grid>
                                        )}
                                        {surveyData.orderInfo.arrivalDateCustoms && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Fecha llegada a Aduana:</strong> {formatCustomDateIsoString(String(surveyData.orderInfo.arrivalDateCustoms))}
                                                </p>
                                            </Grid>
                                        )}
                                        {surveyData.orderInfo.transitTime !== null && surveyData.orderInfo.transitTime !== undefined && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Tiempo en tránsito:</strong> {surveyData.orderInfo.transitTime} días
                                                </p>
                                            </Grid>
                                        )}
                                    </Grid>
                                </div>
                            )}

                            <Grid container spacing={2}>
                                {surveyData.questionsWithAnswers && surveyData.questionsWithAnswers.map((item) => (
                                    <Grid item xs={12} key={item.questionNumber}>
                                        <div  style={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            padding: '20px',
                                            backgroundColor: '#fff'
                                        }}>
                                            <p className="select-form-label" style={{ 
                                                color: '#6C5CE7', 
                                                fontWeight: 'bold',
                                                marginBottom: '10px',
                                                fontSize: '16px'
                                            }}>
                                                Pregunta {item.questionNumber}
                                            </p>
                                            <p className="detail-label" style={{ 
                                                marginBottom: '15px', 
                                                fontSize: '14px',
                                                color: '#333'
                                            }}>
                                                {item.questionText}
                                            </p>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                padding: '10px',
                                                backgroundColor: '#f0f0f0',
                                                borderRadius: '5px'
                                            }}>
                                                <span style={{ fontWeight: 'bold', color: '#6C5CE7' }}>
                                                    Respuesta:
                                                </span>
                                                <span style={{ 
                                                    fontSize: '18px', 
                                                    fontWeight: 'bold',
                                                    color: '#333'
                                                }}>
                                                    {item.answer}/10
                                                </span>
                                            </div>
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    </div>
                )}
            </ModalComponent>

            <CustomSnackbar
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={() => setSnackbarOpen(false)}
            />
        </>
    )
}

export default ViewSurveyResultsModal
